























































































import { Component } from "vue-property-decorator";
import { UsuariosService, Usuario, FiltroUsuarios } from "@/services/usuarios.service";
import DataTable from "@/shared/components/data-table.vue";
import { dateTime } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import ComboRoles from "./components/ComboRoles.vue";
import { ServerPageOptions } from "@/shared/utils/datatable";

@Component({
  components: { DataTable, Tooltip, Confirm, ComboRoles },
  filters: { dateTime },
})
export default class Usuarios extends mixins(GlobalMixin) {
  url = "";

  ativosItens: { key: boolean | null; value: string }[] = [
    {
      key: null,
      value: "",
    },
    {
      key: true,
      value: "Sim",
    },
    {
      key: false,
      value: "Não",
    },
  ];

  filtro: FiltroUsuarios = {
    role: null,
    txtPesquisa: "",
    ativo: true,
    offset: 0,
    limit: 100,
    order: "",
  };

  promise: Promise<Usuario[]> | null = null;
  selectRow = true;

  headers = [
    { value: "nome", text: "Nome" },
    { value: "slug", text: "Slug" },
    { value: "email", text: "Email" },
    { value: "ativo", text: "Ativo" },
    { value: "roles", text: "Roles", sortable: false },
    { value: "actions", text: "Ações", sortable: false },
  ];

  fetchUsers(options?: ServerPageOptions) {
    if (options){
      Object.assign(this.filtro, options);
    }
    this.promise = UsuariosService.Lista(this.filtro);
  }

  async novoItem() {
    this.$router.push({
      name: "usuarios-criar",
    });
  }

  selecionadoUsuario(item: any) {
    this.$router.push({
      params: {
        id: item.idUsuario,
      },
      name: "usuarios-alterar",
    });
  }

  alterarSenha(item: any) {
    this.$router.push({
      params: {
        id: item.idUsuario,
      },
      name: "usuarios-alterar-senha",
    });
  }

  async excluirItem(item: any) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir usuário?`;
    const text = `Deseja realmente deletar este usuário?`;
    const res = await modalConfirm.open(title, text);

    if (res) {
      await UsuariosService.Excluir(item.idUsuario);
      this.fetchUsers();
    }
  }
}
